import { resourceText } from 'src/app/shared/services/localization';
import { Component, Input, OnInit, OnDestroy, Output } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { throwIfEmpty } from 'rxjs/operators';
import { ProfileService } from '../profile/profile/profile.service';
import { GlobalService } from '../services/global.service';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/account/auth.service';
import { CountriesService } from '../services/countries.service';
import { VerifiedCheckinPhone } from '../../core/self-checkin/self-checkin-flow.service';

@Component({
    selector: 'app-phone-verify',
    templateUrl: './phone-verify.component.html',
    styleUrls: ['./phone-verify.component.scss'],
    standalone: false
})
export class PhoneVerifyComponent implements OnInit, OnDestroy {

  @Input() dial_code: string;
  @Input() phone_number: string;
  @Input() enabled: boolean;
  @Input() phoneConfirmed: boolean = false;
  @Input() portrait: boolean = false;
  @Input() userExists: boolean = false;
  @Input() authenticateOnVerify: boolean = true;
  @Input() checkinMode = false;
  @Input() signupMode = false;
  @Output() verified = new EventEmitter<VerifiedCheckinPhone>();
  @Output() stepChange = new EventEmitter<number>();
  @Output() existingAccount = new EventEmitter<boolean>();
  @Output() verificationProof = new EventEmitter<string>();
  @Output() confirmNumber = new EventEmitter<string>();
  @Output() clearEvent = new EventEmitter();
  @Output() failed = new EventEmitter();

  sendCodeValue: string = '';
  verificationCode: string = '';
  sendStatus: number = 0;
  phoneVerificationClosed: boolean = true;
  errorMessage: string = '';
  countryCode = 'US';
  resendSeconds = 0;
  sentAgain = false;
  private cooldown: ReturnType<typeof setInterval>;
  private destroyed = false;
  constructor(public globalService: GlobalService, private profileService: ProfileService, private _router: Router, private authService: AuthService, public countries: CountriesService) { }

  ngOnInit(): void {
    this.phone_number = this.phone_number || '';
    if (this.phoneConfirmed == true)
      this.sendStatus = 2;
  }

  sendingCode = false;
  verifyingCode = false;
  text(english: string, arabic: string) { return this.globalService.translateText(english); }
  get maskedNumber() { return this.dial_code + ' ••• ••• ' + (this.phone_number || '').slice(-4); }
  get phoneCountries() { return this.countries.CountriesList.filter(country => /^\+?[\d\s]+$/.test(country.dial_code)); }
  changeDialCode(code: string) {
    const country = this.countries.CountriesList.find(item => item.code === code);
    if (country) { this.countryCode = code; this.dial_code = country.dial_code.replace(/\s/g,''); this.errorMessage = ''; }
  }
  ngOnDestroy() { this.destroyed = true; clearInterval(this.cooldown); }
  private startCooldown() {
    clearInterval(this.cooldown); this.resendSeconds = 30;
    this.cooldown = setInterval(() => { if (--this.resendSeconds <= 0) clearInterval(this.cooldown); }, 1000);
  }

  async SendCode() {
    if (this.sendingCode || this.verifyingCode) return;
    if (this.checkinMode && this.sendStatus === 1 && this.resendSeconds > 0) return;
    if (this.checkinMode) {
      this.phone_number = (this.phone_number || '').replace(/[\s()-]/g,'');
      if (!/^\d{7,15}$/.test(this.phone_number) || (this.dial_code.replace(/\D/g,'') + this.phone_number).length > 15) {
        this.errorMessage = resourceText('ENTER_A_VALID_MOBILE_NUMBER_WITH_THE_SELECTED_DIALING_CODE'); return;
      }
    }
    this.errorMessage = '';
    this.sendingCode = true;
    try {
    if (this.signupMode) {
      const phone = this.phone_number;
      const availability = await this.authService.signupAvailability('phone', phone);
      if (this.destroyed || this.phone_number !== phone) return;
      if (typeof availability?.exists !== 'boolean') throw new Error('Invalid availability response');
      this.existingAccount.emit(availability.exists);
      if (availability.exists) { this.errorMessage = resourceText('AN_ACCOUNT_ALREADY_EXISTS_SIGN_IN_OR_RESET_YOUR_PASSWORD_BELOW'); return; }
    }
    if (this.userExists) {
      var user = await this.profileService.getUserIdByPhoneNumber(this.phone_number);
      if (user == '')
      {
        this.errorMessage = resourceText('NO_ACCOUNT_IS_ASSOCIATED_WITH_THIS_PHONE_NUMBER');
        return;
      }
    }

    var result = await this.profileService.sendCodeByPhone(this.dial_code + this.phone_number);
    if (this.destroyed) return;
    if (typeof result?.message !== 'string' || result.message !== '') {
      this.errorMessage = result?.message || resourceText('WE_COULD_NOT_SEND_A_TEXT_CHECK_YOUR_CONNECTION_AND_TRY_AGAIN'); return;
    }
    this.sentAgain = this.sendStatus === 1;
    this.verificationCode = "";
    if (result.message == '')
      this.sendStatus = 1;
    if (this.checkinMode) this.startCooldown();
    if (this.checkinMode) this.stepChange.emit(this.sendStatus);
    }
    catch { this.errorMessage = resourceText('UNABLE_TO_SEND_THE_CODE_PLEASE_TRY_AGAIN'); }
    finally { this.sendingCode = false; }
  }

  async VerifyCode() {
    if (this.verifyingCode || this.sendingCode) return;
    if (this.checkinMode && !/^\d{4}$/.test(this.verificationCode || '')) {
      this.errorMessage = resourceText('ENTER_THE_FOUR_DIGIT_CODE_FROM_YOUR_TEXT_MESSAGE'); return;
    }
    this.verifyingCode = true;
    try {
    var result = await this.profileService.VerifyPhoneNumberByRequestId(
      this.dial_code + this.phone_number,
      this.verificationCode,
      this.authenticateOnVerify
    );
    if (this.destroyed) return;
    if (result.message == '') { // Code Verified
      if (this.checkinMode && !result.id && !result.verificationToken) throw new Error('Missing phone verification proof');
      this.errorMessage = '';
      this.authService.checkinDevices.save(result.id, result.checkinDeviceToken);
        if (this.authenticateOnVerify && result['firstName'] != undefined && result['firstName'] != '')
        await this.authService.handleAuthentication(result['email'], result['id'], result['memberId'], result['isLeader'],
          result['firstName'], result['lastName'], result['phoneNumber'], result['roles'], result['token'],
          result['expiration'], result['language']);
      if (this.destroyed) return;
      this.phoneConfirmed = true;
      this.sendStatus = 2;
      clearInterval(this.cooldown);
      this.verificationProof.emit(result.verificationToken || '');
      this.existingAccount.emit(!!result.id);
      this.confirmNumber.emit(this.phone_number);
      if (this.checkinMode) this.verified.emit({phoneNumber:this.phone_number, dialCode:this.dial_code,
        countryCode:this.countryCode, userId:result.id, memberId:result['memberId'], verificationToken:result.verificationToken});
    }
    else {
      this.errorMessage = result.message || 'Unable to verify the code. Please try again.';
      this.phoneConfirmed = false;
      this.failed.emit();
    }

  }

    catch { this.phoneConfirmed = false; this.errorMessage = resourceText('UNABLE_TO_VERIFY_THE_CODE_PLEASE_TRY_AGAIN'); }
    finally { this.verifyingCode = false; }
  }

  phoneNumberChange(event)
  {
      this.errorMessage = '';
  }

  Clear() {
    if (this.sendingCode || this.verifyingCode) return;
    clearInterval(this.cooldown); this.resendSeconds = 0; this.sentAgain = false; this.errorMessage = '';
    this.phoneConfirmed = false;
    this.phone_number = '';
    this.verificationCode = "";
    this.sendStatus = 0;
    if (this.checkinMode) this.stepChange.emit(0);
    this.clearEvent.emit();
  }

  Retry() {
    this.errorMessage = "";
    this.Clear();
  }

  Signup() {
    this._router.navigate(['/signup']);
  }

}
